import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Button, CircularProgress, IconButton, TableCell, TableRow, Tooltip, Typography } from '@mui/material';
import React, { Component } from 'react';

import { ExerciseSearchItem } from '../../api/exercises.interface';
import ExerciseHoverVideoTitle from './ExerciseHoverVideoTitle';

interface Props {
    deletingTag?: number;
    item: ExerciseSearchItem;
    selectedExerciseTags?: number[];
    selectionMode: 'none' | 'single' | 'multiple';
    onDeleteExercise: (item: ExerciseSearchItem) => void;
    onEditExercise: (index: number) => void;
    onSelectExercise?: (item: ExerciseSearchItem) => void;
}

class ExerciseResultsRow extends Component<Props> {
    onDeleteClick = () => {
        this.props.onDeleteExercise(this.props.item);
    };

    onEditClick = () => {
        this.props.onEditExercise(this.props.item.index);
    };

    onSelectClick = () => {
        this.props.onSelectExercise?.(this.props.item);
    };

    render() {
        const { deletingTag, item, selectedExerciseTags, selectionMode } = this.props;
        const deletingThisRow = deletingTag === item.tag;
        const alreadySelected = Boolean(selectedExerciseTags?.includes(item.tag));

        return (
            <TableRow hover>
                <TableCell>
                    <ExerciseHoverVideoTitle title={item.exercise} titleVariant="body2" videoUrl={item.videoUrl} />
                </TableCell>
                <TableCell>{item.tag}</TableCell>
                <TableCell>{item.level}</TableCell>
                <TableCell>{item.plan}</TableCell>
                <TableCell>{item.reps}</TableCell>
                <TableCell>{item.weightRange}</TableCell>
                <TableCell align="right">
                    {selectionMode === 'single' && (
                        <Button onClick={this.onSelectClick} size="small" variant="contained">Select</Button>
                    )}
                    {selectionMode === 'multiple' && (
                        <Button disabled={alreadySelected} onClick={this.onSelectClick} size="small" variant="contained">
                            {alreadySelected ? 'Added' : 'Add'}
                        </Button>
                    )}
                    {selectionMode === 'none' && (
                        <>
                            <Tooltip title="Edit exercise">
                                <span>
                                    <IconButton color="primary" onClick={this.onEditClick} size="small">
                                        <EditOutlinedIcon fontSize="small" />
                                    </IconButton>
                                </span>
                            </Tooltip>
                            <Tooltip title="Delete exercise">
                                <span>
                                    <IconButton color="error" disabled={deletingThisRow} onClick={this.onDeleteClick} size="small">
                                        {deletingThisRow ? <CircularProgress size={18} /> : <DeleteOutlineRoundedIcon fontSize="small" />}
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </>
                    )}
                </TableCell>
            </TableRow>
        );
    }
}

export default ExerciseResultsRow;